import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromEventMonitoring from './reducers/event-monitoring.reducer';
import { EffectsModule } from '@ngrx/effects';
import { EventMonitoringEffects } from './effects/event-monitoring.effects';
import * as fromEventFilters from './reducers/event-filters.reducer';
import { EventFiltersEffects } from './effects/event-filters.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('eventMonitoring', fromEventMonitoring.reducer),
    EffectsModule.forFeature([EventMonitoringEffects, EventFiltersEffects]),
    StoreModule.forFeature('eventFilters', fromEventFilters.reducer)
  ]
})
export class EventMonitoringModule { }
